import {Component, effect, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatCard, MatCardContent} from '@angular/material/card';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {UserHal} from '../../models/HAL/user-hal.model';
import {TranslatePipe} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {SessionService} from '../../services/session.service';
import {LoadingSpinnerService} from '../../services/loading-spinner.service';

@Component({
  selector: 'app-user-menu',
  imports: [
    MatCard,
    MatCardContent,
    MatIconButton,
    MatIcon,
    MatButton,
    TranslatePipe
  ],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss'
})
export class UserMenuComponent implements OnInit {

  @Input()
  user: UserHal | undefined;
  @Output()
  closeUserMenu = new EventEmitter<void>();
  userInitials: string = ':O';
  teamSelected: boolean = false;

  constructor(private readonly router: Router,
              private readonly sessionService: SessionService,
              private readonly loadingSpinnerService: LoadingSpinnerService) {
    effect(() => {
      if (this.sessionService.session().user !== undefined) {
        this.teamSelected = !!this.sessionService.session().currentTeam;
      }
    });
  }

  ngOnInit() {
    this.setUserInitials();
  }

  setUserInitials() {
    if (this.user) {
      this.userInitials = (this.user.firstName.charAt(0) + this.user.lastName.charAt(0)).toUpperCase();
    }
  }

  changeTeam() {
    this.loadingSpinnerService.show();
    this.sessionService.unselectTeam();
    this.router.navigate(['/teams']).then();
    this.closeUserMenu.emit();
  }

  logout() {
    this.loadingSpinnerService.show();
    this.router.navigate(['/logout']).then();
    this.closeUserMenu.emit();
  }
}
